export const resetTextRotation = () => {
  const activeObject = window.canvas.getActiveObject();
  activeObject.rotate(0);
  window.canvas.renderAll();
};
